import { memo } from 'react';
import { getColorToDisplay, IGetColorToDisplay } from '../../../calculations/getFunctions';
import styles from './TeamSummaryCard.module.css';

interface ISummaryCardCell {
  style?: React.CSSProperties;
  colorToDisplay?: IGetColorToDisplay;
  header?: boolean;
  children?: React.ReactNode;
}

export const SummaryCardCell = memo(({ children, style, colorToDisplay, header }: ISummaryCardCell) => {
  const color = colorToDisplay ? getColorToDisplay(colorToDisplay) : {};
  return (
    <div style={{ ...color, ...style }} className={header ? styles.headingColumn : styles.column}>
      {header ? children : <p>{children}</p>}
    </div>
  );
});
